import { RegistrationFormProvider } from '@/app/_auth/steps/_common/registration-form-context'
import { CreateAccountStep } from '@/app/_auth/steps/create-account-step'
import { DeactivatedStep } from '@/app/_auth/steps/deactivated-step'
import { ErrorStep } from '@/app/_auth/steps/error-step'
import { GetSessionDataStep } from '@/app/_auth/steps/get-session-data-step'
import { LinkProviderStep } from '@/app/_auth/steps/link-provider-step'
import { LoginStep } from '@/app/_auth/steps/login-step'
import { RegisterConsentStep } from '@/app/_auth/steps/register-consent-step'
import { RegisterOrgStep } from '@/app/_auth/steps/register-org-step'
import { RegisterPurposeStep } from '@/app/_auth/steps/register-purpose-step'
import { Toaster } from '@/components/ui/toaster'
import React from 'react'

// 👇 step data

export enum AuthStep {
  Create = 'create',
  Login = 'login',
  LinkProvider = 'link-provider',
  Deactivated = 'deactivated',
  GetSessionData = 'get-session-data',
  RegisterOrg = 'register-org',
  RegisterPurpose = 'register-purpose',
  RegisterConsent = 'register-consent',
  Error = 'error',
}

const AUTH_STEP_COMPONENT: Record<AuthStep, React.FC> = {
  [AuthStep.Login]: LoginStep,
  [AuthStep.LinkProvider]: LinkProviderStep,
  [AuthStep.Create]: CreateAccountStep,
  [AuthStep.GetSessionData]: GetSessionDataStep,
  [AuthStep.Deactivated]: DeactivatedStep,
  [AuthStep.RegisterOrg]: RegisterOrgStep,
  [AuthStep.RegisterPurpose]: RegisterPurposeStep,
  [AuthStep.RegisterConsent]: RegisterConsentStep,
  [AuthStep.Error]: ErrorStep,
}

// 👇 components

export function AuthStepNavigator({ step }: Readonly<{ step: AuthStep }>) {
  const AuthStepComponent = AUTH_STEP_COMPONENT[step]

  return (
    <RegistrationFormProvider>
      <Toaster />
      <AuthStepComponent />
    </RegistrationFormProvider>
  )
}

export function AuthGuard({ step, children }: React.PropsWithChildren<{ step: AuthStep | null }>) {
  if (step === null) return children
  return <AuthStepNavigator step={step} />
}
